export interface ITreatyParts {
  count: number
  urls: string[]
}
